let current = null;
const listeners = new Set();
export const getCallActivity = () => current;
export function subscribeCallActivity(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function beginCallActivity(roomId, userId) {
  if (current) throw new Error("Leave your current call before joining another.");
  const identity = { roomId, userId };
  current = identity;
  listeners.forEach((listener) => listener(current));
  return () => {
    if (current !== identity) return;
    current = null;
    listeners.forEach((listener) => listener(null));
  };
}
